// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__3zA7n"};